import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { useCatalog } from '../../../contexts/CatalogContext';
import { useSignedInAccount } from '../../../contexts/AccountContext';
import { euro } from '../../../core/format/currency';
import { plural } from '../../../core/format/text';
import { dayLong, newestFirst, orderTotal } from '../../../utils/account';
import { giftCardCheck, isGiftCardOnly, orderHref } from '../../../utils/accountOrders';
import { accountHeading } from '../../../ui/sections';
import { orderStatusLabel, orderStatusTone } from '../orderStatus';

/** Zoveel bestellingen staan op Thuis; de rest (met facturen) op Bestellingen. */
const RECENT = 3;

/** De laatste bestellingen als lijst: datum, status en bedrag, één tik naar de details. */
export function RecentOrders() {
  const {
    account
  } = useSignedInAccount();
  const {
    productById
  } = useCatalog();
  const isGift = giftCardCheck(productById);
  const orders = newestFirst(account.orders);
  if (!orders.length) return null;
  return <section aria-labelledby="recent-orders-title" data-id="element-6492" data-mp="16yna3y8cfmok">
      <div className="flex flex-wrap items-end justify-between gap-x-4 gap-y-2" data-id="element-6493" data-mp="1bwf3yxsjtive">
        <h2 id="recent-orders-title" className={accountHeading} data-id="element-6494" data-mp="1by9oiazwr8yy">
          Bestellingen
        </h2>
        <Link to="/account/bestellingen" className="inline-flex items-center gap-1 whitespace-nowrap text-[14px] text-muted transition-colors duration-150 ease-soft hover:text-ink" data-id="element-6495" data-mp="1gxw2imnk8t8t">
          {orders.length > RECENT ? `Alle ${orders.length} en facturen` : 'Details en facturen'}
          <ArrowRightIcon className="h-3.5 w-3.5" strokeWidth={1.5} aria-hidden="true" data-id="element-6496" data-mp="1utga4lxu9p0x" />
        </Link>
      </div>
      <ul className="mt-4 divide-y divide-line border-y border-line" data-id="element-6497" data-mp="1zo3x2gd72bde">
        {orders.slice(0, RECENT).map(o => {
        const label = orderStatusLabel(o, isGiftCardOnly(o, isGift));
        const count = o.lines.reduce((n, l) => n + l.qty, 0);
        return <li key={o.id} data-id="element-6498" data-mp="2dmbqwfexowkc">
              <Link to={orderHref(o.id)} className="flex items-center gap-3 py-4 transition-colors duration-150 ease-soft hover:bg-sand/50 sm:gap-4 sm:px-2" data-id="element-6499" data-mp="2djftcs7009wf">
                <span className="min-w-0 flex-1" data-id="element-6500" data-mp="9j8s7w6qfb7g">
                  <span className="block truncate text-[15px] capitalize text-ink" data-id="element-6501" data-mp="n9cakc2hqkrm">{dayLong(o.date)}</span>
                  <span className="block text-[13px] text-muted" data-id="element-6502" data-mp="iivwqqurcx4q">
                    #{o.id} · {plural(count, 'product', 'producten')}
                  </span>
                </span>
                <span className={`shrink-0 whitespace-nowrap rounded-full px-2.5 py-1 text-[12px] ${orderStatusTone(label)}`} data-id="element-6503" data-mp="x9cxs93hdl13">
                  <span className="sr-only" data-id="element-6504" data-mp="168q791rlu9lt">Status: </span>
                  {label}
                </span>
                <span className="w-16 shrink-0 text-right text-[15px] tabular-nums text-ink sm:w-20" data-id="element-6505" data-mp="118vip4vaxw3x">{euro(orderTotal(o))}</span>
              </Link>
            </li>;
      })}
      </ul>
    </section>;
}